import { Component, Inject, OnInit, ViewChild } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { NavigationEnd, Router } from '@angular/router';
import { select, Store } from '@ngrx/store';
import { ImageCroppedEvent } from 'ngx-image-cropper';
import { Observable, Subscription } from 'rxjs';
import { ButtonTypeAttributeEnum } from '@hrra/ui';
import { ButtonTypeEnum } from '@hrra/ui';
import { approveJobseekerPhoto, editJobseekerPhoto, insertCroppedImage, selectJobseekerPhoto } from 'src/app/root-store/jobseeker-store/jobseeker-profile/actions';
import { selectPhotoIsSelected, selectBase64, selectIsPhotoApproved, selectIsJobseekerProfileUpdating, selectJobseekerModerationLastChangeDate } from 'src/app/root-store/jobseeker-store/jobseeker-profile/selectors';
import { AppState } from 'src/app/root-store/state';

@Component({
    selector: 'app-jobseeker-photo-edit',
    templateUrl: './jobseeker-photo-edit.component.html',
    styleUrls: ['./jobseeker-photo-edit.component.scss'],
    standalone: false
})
export class JobseekerPhotoEditComponent implements OnInit {

  @ViewChild('hiddenfileinput') fileInput: any;
  
  navigationSubs: Subscription;

  public photoHref: string;
  public isPhotoPending: boolean;
  public buttonType: any;
  public buttonAttributeType: any;
  moderationLastChangeDate$: Observable<Date>;


  photoIsSelected$: Observable<boolean>;
  photoIsApproved$: Observable<boolean>;
  base64$: Observable<string>;
  isUpdating$: Observable<boolean>;

  imageChangedEvent: any = '';

  constructor(private store: Store<AppState>, @Inject(MAT_DIALOG_DATA) public data, private router: Router, public dialogRef: MatDialogRef<JobseekerPhotoEditComponent>) {
    this.buttonType = ButtonTypeEnum;
    this.buttonAttributeType = ButtonTypeAttributeEnum;

    this.navigationSubs = this.router.events.subscribe(e => {
      if(e instanceof NavigationEnd){
        this.dialogRef.close();
      }
    });
   }

  ngOnInit(): void {
    this.photoHref = this.data.photoHref;
    this.isPhotoPending = this.data.isPhotoPending;

    this.moderationLastChangeDate$ = this.store.pipe(select(selectJobseekerModerationLastChangeDate));
    this.photoIsSelected$ = this.store.pipe(select(selectPhotoIsSelected));
    this.photoIsApproved$ = this.store.pipe(select(selectIsPhotoApproved));
    this.base64$ = this.store.pipe(select(selectBase64));
    this.isUpdating$ = this.store.pipe(select(selectIsJobseekerProfileUpdating));
  }
  
  fileChangeEvent(event: any): void {
      this.imageChangedEvent = event;
      this.store.dispatch(selectJobseekerPhoto());
  }
  imageCropped(event: ImageCroppedEvent) {
      this.store.dispatch(insertCroppedImage({payload: {base64: event.base64}}));
      this.fileInput.nativeElement.value = '';
  }

  onSave(base64: string, moderationLastChangeDate: Date, isPhotoSelected: boolean){


    if(base64 == null){
      this.dialogRef.close();
    }
    else{
      if(isPhotoSelected){
       this.store.dispatch(approveJobseekerPhoto());
      }
      let result = base64.replace("data:image/png;base64,", "");
      this.store.dispatch(editJobseekerPhoto({payload: {jobseekerPhotoModel: result, moderationLastChangeDate: moderationLastChangeDate}}));
    }
  }


  ngOnDestroy() {
    this.navigationSubs.unsubscribe();
  }
}